// Ajustes do tema só do app mobile. Vazio por enquanto (ponto de extensão).
const mobile = () => ({});

export default mobile;
